import * as React from 'react';
import { useTranslation } from 'next-i18next';
import tw from 'twin.macro';
import { useAtom } from 'jotai';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';

import { User } from '@restworld/utility-types';
import { FormLabelWrapper, TextInput } from '@restworld/ui-ds';
import { useEmployerUserContactData } from '@restworld/feature-authentication';

import { useEmployerUserInformationMutation } from './use-employer-user-information';

import { modalUserInformationVisibleAtom } from '.';
import { ModalToggleWrapper } from './form-modal-wrapper';

export const EditUserInformationModal = () => {
  const employerUserInformation = useEmployerUserContactData();
  const { t } = useTranslation('user-settings');
  const methods = useForm<User>();
  const [modalVisible, modalVisibleToggler] = useAtom(modalUserInformationVisibleAtom);
  const formItems = React.useMemo(() => {
    return (
      <>
        <FormLabelWrapper label="Name">
          <Controller
            name="name"
            rules={{
              required: t('name_is_required'),
            }}
            control={methods.control}
            render={({ field }) => <TextInput wrapperStyle={tw`px-0`} placeholder="Max" id="name" {...field} />}
          />
        </FormLabelWrapper>
        <FormLabelWrapper label="Surname">
          <Controller
            name="surname"
            rules={{
              required: t('surname_is_required'),
            }}
            control={methods.control}
            render={({ field }) => <TextInput wrapperStyle={tw`px-0`} placeholder="Payne" id="name" {...field} />}
          />
        </FormLabelWrapper>
      </>
    );
  }, [methods.control, t]);
  const { mutate, isPending } = useEmployerUserInformationMutation();

  const onSubmit: SubmitHandler<User> = React.useCallback(
    (data) => {
      mutate({
        ...{
          ...employerUserInformation.user,
          name: data.name,
          surname: data.surname,
        },
      });
    },
    [employerUserInformation, mutate]
  );

  const handleReset = React.useCallback(() => {
    methods.reset({});
    modalVisibleToggler(false);
  }, [methods, modalVisibleToggler]);

  React.useEffect(() => {
    if (employerUserInformation?.user) methods.reset(employerUserInformation.user);
  }, [employerUserInformation?.user, methods]);

  return (
    <ModalToggleWrapper
      onSubmitHandler={methods.handleSubmit(onSubmit)}
      onCancelHandler={handleReset}
      loading={isPending}
      modalVisible={modalVisible}
      onModalClose={handleReset}
      title={t('name_and_surname')}
    >
      {formItems}
    </ModalToggleWrapper>
  );
};
